import CredentialManagement from 'components/CredentialManagement/summary';
import PrivateRoute from 'utils/privateRoute';


const credManagementRoutes = [
    {
        key: 'cred_mgmt_summary',
        route: '/credsManagement/summary',
        component: (
            <PrivateRoute
                Component={CredentialManagement}
                title="Credential Management Summary"
                restrictedRoles={[]}
            />
        )
    },
];

export default credManagementRoutes;
